import React, { FC } from 'react'
import styled from 'styled-components'

import { PractitionerSettings } from '../../../../../lib/practitioner-settings/types'
import Spacer from '../../../../Spacer'
import { AchAccountInformation } from './AchAccountInformation'
import { W9TaxpayerIdentification } from './W9TaxpayerIdentification'

export interface AccountDocumentsSectionProps {
  className?: string
  settings: PractitionerSettings
}

const StyledHeader = styled.h2`
  font-family: ${({ theme }) => theme.fontFamilies.gotham};
  font-size: 24px;
  color: #001b36;
  margin-bottom: 8px;
`

const StyledDescription = styled.p`
  && {
    font-family: ${({ theme }) => theme.fontFamilies.roboto};
    font-size: 16px;
    color: #001b36;
    margin-bottom: 0;
  }
`

const AccountDocumentsSection: FC<AccountDocumentsSectionProps> = ({ className, settings }) => {
  return (
    <section className={className}>
      <StyledHeader>Account Documents</StyledHeader>
      <StyledDescription>Required forms for participation in rewards program</StyledDescription>
      <Spacer size={4} />
      <AchAccountInformation settings={settings} />
      <Spacer size={4} />
      <W9TaxpayerIdentification settings={settings} />
    </section>
  )
}

export default AccountDocumentsSection
